<template>
    <div>
        <nav class="navbar header-navbar pcoded-header">
            <div class="navbar-wrapper">

                <div class="navbar-logo">
                    <a class="mobile-menu" id="mobile-collapse" href="javascript:void(0)">
                        <i class="ti-menu"></i>
                    </a>
                    <a href="/dashboard" style="width: 100px; margin-top: 0px;">
                        <img class="img-fluid" src="../assets/img/logo.png" alt="Waje Smart" />
                    </a>
                    <a class="mobile-options">
                        <i class="ti-more"></i>
                    </a>
                </div>

                <div class="navbar-container container-fluid">
                    <ul class="nav-left">
                        <li>
                            <div class="sidebar_toggle"><a href="javascript:void(0)"><i class="ti-menu"></i></a></div>
                        </li>
                        <li>
                            <a href="#" onclick="javascript:toggleFullScreen()">
                                <i class="ti-fullscreen"></i>
                            </a>
                        </li>
                    </ul>
                    <ul class="nav-right">
                        <li class="user-profile header-notification">
                            <a href="javascript:void(0)">
                                <img src="@/assets/img/avatar-4.png" class="img-radius" v-bind:alt="user_data.firstname">
                                <span>{{user_data.firstname + " " + user_data.lastname}}</span>
                                <i class="ti-angle-down"></i>
                            </a>
                            <ul class="show-notification profile-notification">
                                <li>
                                    <a href="javascript:void(0)" data-toggle="modal" data-target="#changePassword">
                                        <i class="ti-key"></i> Change Password
                                    </a>
                                </li>
                                <!-- <li>
                                    <a href="javascript:void(0)">
                                        <i class="ti-user"></i> Profile
                                    </a>
                                </li> -->
                                <li>
                                    <a href="javascript:void(0)" v-on:click="logout">
                                        <i class="ti-layout-sidebar-left"></i> Logout
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div id="changePassword" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Password</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="changePassword" role="form">
                            <div class="form-group">
                                <input type="password" name="old_password" v-model="new_pass.old_password" class="form-control" required="required" placeholder="Old Password" />
                            </div>
                            <div class="form-group">
                                <input type="password" name="new_password" v-model="new_pass.new_password" class="form-control" required="required" placeholder="New Password" />
                            </div>
                            <div class="form-group">
                                <input type="password" name="re_password" v-model="new_pass.re_password" class="form-control" required="required" placeholder="Repeat Password" />
                            </div>
                            <div class="form-group">
                                <span class="label label-danger" v-if="new_pass.re_password.length > 0 && new_pass.new_password !== new_pass.re_password">Passwords do not match</span>
                                <button class="btn btn-primary" v-else>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Navbar1',
        data(){
            return{
                user_data: this.$store.getters.user_data.data,
                new_pass: {
                    applicant_id: this.$store.getters.user_data.data.id,
                    old_password: '',
                    new_password: '',
                    re_password: ''
                }
            }
        },
        methods:{
            logout(){
    
                var r = window.confirm('Are you sure you want to logout?')

                if(r == true){
                    this.$store.dispatch('logout')
                    window.location.reload()
                } else{
                    //
                }
            },

            toggleFullScreen() {
                
            },

            changePassword: function(){
                let update_pass = {
                    what: "ChangePassword",
                    data: this.new_pass
                }

                this.$socket.makePostRequest(update_pass)
                    .then((response)=>{
                        if(response.type == "ChangePassword"){
                            this.$swal.fire('Success', response.data.message, 'success')

                            setTimeout(window.location.reload(), 3000)
                        }
                    })
                    .catch((error)=>{
                        console.log(error)
                        this.$swal.fire('Error', error.data.message, 'error')
                    })
            }
        },
        mounted(){
            var user = this.$store.getters.user_data

            this.user_name = user.name

        }
    }
</script>